import React from "react";
import { WithFormProps } from "src/components/forms/Form";
import ClassModel from "src/models/ClassModel";
import PrivateSerieModel from "src/models/PrivateSerieModel";
import { withSession, WithSessionProps } from "src/stores/Session";
import { StoreProps, withStore } from "src/stores/Store";
import compose from "src/utils/compose";
import { InputItem } from "../inputs/InputItem";
import InputTextarea from "../inputs/InputTextarea";

interface Props extends StoreProps, WithSessionProps, WithFormProps {
  privateSerie?: PrivateSerieModel;
  offering?: ClassModel;
}

interface State {}

class CustomerInfoRequestResponses extends React.Component<Props, State> {
  render() {
    const { privateSerie, form, store, session } = this.props;
    const { getFieldDecorator } = form;

    let offering;

    if (privateSerie && privateSerie.offering) {
      offering = privateSerie.offering;
    } else if (this.props.offering) {
      offering = this.props.offering;
    }

    if (offering.customerInfoRequests.length === 0) {
      return null;
    }

    const customerInfoRequests = offering.customerInfoRequests.map((c, i) => {
      let initialValue;
      const label = c;
      // getFieldDecorator uses dot.notation to update paths. This
      // info req may have a period bc it is free form text by user
      let key = `cirr:${c.replace(".", "_UNSAFE_PERIOD_")}:${i}`;

      let existingResponse;

      if (privateSerie) {
        existingResponse = privateSerie.customerInfoRequestResponses.find(
          (r) => r.question === c
        );
      } else if (offering) {
        existingResponse = session.groupRegistrations.find(
          (r) =>
            r.class.id === offering.id &&
            r.customerInfoRequestResponses.find((cr) => cr.question === c)
        );
      }

      if (existingResponse) {
        initialValue = existingResponse.answer;
        key = `cirr-${existingResponse.id}:${i}`;
      }

      return (
        <InputItem label={label} key={i}>
          {getFieldDecorator(key, {
            initialValue,
            rules: [
              {
                required:
                  store.user && store.user.isAdminOrAbove ? false : true,
                message: "Please enter a response",
                whitespace: true,
              },
            ],
          })(<InputTextarea placeholder="Response" />)}
        </InputItem>
      );
    });

    return <div className="mb-8 text-left">{customerInfoRequests}</div>;
  }
}

export default compose(withStore, withSession)(CustomerInfoRequestResponses);
